<template>
  <div class="mod-extra-enter clearfix">
    <div
      :class="['bd','bd-'+type]"
      :style="content.background?{
      backgroundImage: `url(${content.background})`
    }:{}"
    >
    </div>
    <div class="container">
      <div class="prd-wrapper clearfix">
        <div
          :class="[type]"
          v-for="(item,index) in content.infomation"
          :key="index"
          @click="goToSelfUrl(item.url)"
        >
          <img
            v-if="item.image"
            :class="[`product-image-${type}`]"
            :src="item.image"
            alt=""
          >
          <div
            class="title"
            v-if="item.title&&item.title!==''"
          >{{item.title}}</div>
        </div>
      </div>
      <div class="caculator" v-if="type === 'luggage' && !isEmpty(luggagePriceConfig)">
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <td v-for="tItem in tableHead" :key="tItem.type">{{ tItem.title }}</td>
              </tr>
            </thead>
            <tbody>
            <tr v-for="rule in luggagePriceConfig.rules" :key="rule.amount">
              <td>
                <template v-if="rule.min">
                  {{ rule.min }}KM（含）
                </template>
                <template v-if="rule.min && rule.max < Infinity">--</template>
                <template v-if="rule.max < Infinity">
                  {{ rule.max }}KM（不含）
                </template>
                <template v-if="rule.max === Infinity">以上</template>
                <template v-if="!rule.min">以下</template>
              </td>
              <td v-if="(luggagePriceConfig.discount < 1)">{{(rule.amount * luggagePriceConfig.kilo * luggagePriceConfig.discount).toFixed(1)}}</td>
              <td v-if="rule.amount">{{( rule.amount * luggagePriceConfig.kilo )}}</td>
              <td v-if="rule.offlineAmount">{{ rule.offlineAmount }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <caculator :moduleTitle="luggagePriceConfig.moduleTitle" :rules="luggagePriceConfig.rules" :discount="luggagePriceConfig.discount"></caculator>
      </div>

      <div class="foot">
        <a-button
          type="primary"
          size="large"
          class="buy-btn"
          @click="toPay"
          v-if="content.showBuyButton ?? true"
        >马上购买</a-button>
      </div>
      <div class="des">
        <div>
          <div class="title f-26">使用说明</div>
          <div class="content-wrapper">
            <div
              v-for="(item,index) in content.rules"
              :key="index"
            >
              <div class="title clearfix">
                <span>{{item.title}}</span>
                <div
                  class="arrow-wrapper f-right"
                  @click="showView(index)"
                >
                  <i :class="['arrow',item.show?'down':'up']"></i>
                </div>
              </div>
              <div
                class="content clearfix"
                v-if="item.show"
              >
                <div
                  :class="['f-left',item.image?'span':'']"
                  v-html="item.content"
                ></div>
                <img
                  v-if="item.image"
                  class="f-right"
                  :src="item.image"
                  alt=""
                >
              </div>
              <a-divider class="divider" dashed v-if="!item.show && index !== content.rules - 1"></a-divider>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import './index'
import queryString from 'query-string'
import { isEmpty } from 'lodash'
import caculator from './components/caculator'
export default {
  data () {
    return {
      type: 'luggage',
      tabValue: '1',
      content: {},
      mainSettings: window.__MICRO_ROOT__ ?? {},
      luggagePriceConfig: {}
    }
  },
  mounted () {
    this.getCmsData()
  },
  computed: {
    tableHead () {
      const { tableHead, discount } = this.luggagePriceConfig
      return tableHead.filter(item => {
        if (discount < 1) {
          return true
        } else {
          return item.type !== 'eventOnline'
        }
      })
    }
  },
  methods: {
    isEmpty,
    async getCmsData () {
      const query = queryString.parse(location.search)
      const { mainSettings } = this
      const pageData = (await mainSettings.cms?.fetchPageData(query.id)) ?? {}
      if (!pageData?.content) {
        window.__MICRO_ROOT__?.router?.replace('/404')
      }
      const data = pageData.content
      if (data.name) {
        this.type = data.name
        if (data.rules) {
          data.rules.forEach(async (item, index) => {
            // 默认都展开
            if (item.componentid) {
              const newText = (await mainSettings.cms?.fetchItems(item.componentid)) ?? {}
              item.content = newText[item.componentid]?.content
            } else {
              item.content = encodeHtml(item.content)
            }
            this.$set(item, 'show', true)
          })
        }
        this.content = data
      }
      await this.mainSettings.cms?.getPageData().then((res) => {
        const { data } = res?.luggagePriceConfig
        const luggagePriceConfig = JSON.parse(data, (key, value) => {
          return value === 'Infinity' ? Infinity : value
        })

        this.luggagePriceConfig = luggagePriceConfig || {}
      })
    },
    toPay () {
      this.$router.push({ path: '/extraalone/validate' })
    },
    showView (index) {
      const des = this.content.rules[index]
      this.$set(this.content.rules[index], 'show', !des.show)
    },
    goToSelfUrl (url) {
      if (!url) {
        return
      }
      window.location.href = url
    }
  },
  components: {
    caculator
  }
}
function encodeHtml (value) {
  return value.replace(/\n/g, '<br/>').replace(/\s{1}/g, '&nbsp;&nbsp;')
}
</script>

<style lang="less">
.mod-extra-enter {

  .caculator {
    margin-top: 40px;

    .table-wrap {
      text-align: center;
    }

    table {
      color: #333;
      width: 100%;
      margin-top: 10px;
      table-layout: fixed;
    }

    thead {
      tr {
        td {
          background: @primary-color;
          color: #fff;
          font-weight: bold;
          border: 1px solid #333;
          padding: 5px 0;
        }
      }
    }

    tbody {
      tr {
        td {
          border: 1px solid #333;
          padding: 5px 0;
        }
      }
    }
  }

  .bd {
    display: table;
    width: 100%;
    height: 300px;

    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }

  // .bd-luggage,.bd-int-luggage {
  //   background-image: url(./image/luggage.png);
  // }

  // .bd-meal,.bd-int-luggage {
  //   background-image: url(./image/meal.png);
  // }

  // .bd-vip {
  //   background-image: url(./image/vip.png);
  // }

  .tab {
    margin-top: 50px;
    overflow: hidden;

    & > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
      background: @primary-color;
      color: #fff;
    }

    & > .ant-tabs-card > .ant-tabs-bar .ant-tabs-nav-container {
      height: 50px;
    }

    & > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
      margin-right: -1px;
      border-radius: 0;
      min-width: 120px;
      height: 49px;
      line-height: 49px;
      text-align: center;
    }
  }

  .prd-wrapper {
    display: flex;
    flex-wrap: wrap;
    .luggage, .int-luggage {
      margin-top: 20px;
      // width: 200px;
      // height: 200px;
      background: #aaa;
      // position: relative;
      // float: left;
      margin-right: 20px;

      .title {
        background: @primary-color;
        color: #fff;
        font-weight: bold;
        height: 40px;
        line-height: 40px;
        text-align: center;
        width: 200px;
        // position: absolute;
        // left: 0;
        // bottom: 0;
        border-radius: 4px;
      }

      &:nth-child(6n) {
        margin-right: 0;
      }
    }

    .meal, .int-meal {
      // width: 300px;
      // height: 200px;
      margin-top: 20px;
      background: #aaa;
      // position: relative;
      // float: left;
      margin-right: 20px;

      .title {
        background: @primary-color;
        color: #fff;
        font-weight: bold;
        height: 40px;
        line-height: 40px;
        text-align: center;
        width: 300px;
        // position: absolute;
        // left: 0;
        // bottom: 0;
      }

      &:nth-child(4n) {
        margin-right: 0;
      }
    }

    .vip {
      // position: relative;
      // width: 100%;
      // height: 200px;
      margin-top: 40px;
      background: #aaa;
    }

    .product-image-luggage, .product-image-int-luggage {
      display: block;
      position: unset;
      width: 200px;
      height: 200px;
    }

    .product-image-meal, .product-image-int-meal {
      display: block;
      position: unset;
      width: 300px;
      height: 200px;
    }

    .product-image-vip, .product-image-int-vip {
      display: block;
      position: unset;
      width: 100%;
      height: 200px;
    }
  }

  .product-list {
    img {
      width: 100%;
    }
  }

  .foot {
    width: 100%;
    text-align: center;
    margin-top: 30px;

    .buy-btn {
      padding: 0 80px;
    }
  }

  .des {
    margin-top: 40px;
    color: #808080;
    .title {
      font-weight: bold;
      line-height: 60px;
      border-bottom: solid 1px #ddd;
    }

    .content-wrapper {
      background: #f4f4f4;
      padding: 15px 30px;
      margin-top: 20px;
      margin-bottom: 20px;
      border-radius: 4px;
      .title {
        line-height: 40px;
        // border-top: solid 1px #afafaf;
        border-bottom: none;

        .arrow-wrapper {
          display: inline-block;
          cursor: pointer;
        }

        .arrow {
          border: solid #808080;
          border-width: 0 3px 3px 0;
          display: inline-block;
          padding: 5px;
        }

        .down {
          transform: rotate(45deg);
          -webkit-transform: rotate(45deg);
          transition: All 0.1s ease-in-out;
        }

        .up {
          transform: rotate(-135deg);
          -webkit-transform: rotate(-135deg);
          transition: All 0.1s ease-in-out;
        }
      }
      .content {
        padding: 10px 20px;
        margin-bottom: 20px;
        background: #fff;
        border-radius: 4px;
        line-height: 2;
        .span {
          width: 980px;
        }
        img {
          width: 200px;
          height: 150px;
          background: #aaa;
        }
      }
      .divider {
        margin: 10px 0;
        color: #ddd;
        border-color: #ddd;
      }
    }
  }

  .f-26 {
    font-size: 26px;
  }

  .f-16 {
    font-size: 16px;
  }

  .f-left {
    float: left;
  }

  .f-right {
    float: right;
  }

  .m-t-50 {
    margin-top: 50px;
  }
}
@media only screen and (max-width: 768px) {
  .mod-extra-enter {
    .bd {
      width: 100%;
      height: 120px;
    }

    .bd-luggage {
      background-size: contain;
    }

    .bd-meal {
      background-size: contain;
    }

    .bd-vip {
      background-size: contain;
    }

    .tab {
      margin-top: 20px;
    }

    .prd-wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      &::before,
      &:after {
        display: none;
      }

      .luggage {
        float: none;
        margin-right: 0;
        width: 48%;
      }

      .meal {
        float: none;
        margin: 20px auto 0;

        &:nth-child(4n) {
          margin-right: auto;
        }
      }
    }

    .des {
      .content-wrapper {
        padding: 10px;

        .content span {
          width: auto;
        }
      }
    }
  }
}
</style>
